import React from "react";

export const Loader = ({ inline = false }) => {
  return (
    <div className={inline ? "loader-container-inline" : "loader-container"}>
      <div className="loader"></div>
    </div>
  );
};
